import { render } from "./FormActions.vue?vue&type=template&id=86b753d8"
import script from "./FormActions.vue?vue&type=script&lang=js"
export * from "./FormActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__